// extracted by mini-css-extract-plugin
module.exports = {"meetingResultDialog":"client_meetingResultDialog__2wRSK"};